"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAnchorCountFromConfig = exports.lineageItemKey = exports.LineageSectionType = void 0;
var LineageSectionType;
(function (LineageSectionType) {
    LineageSectionType[LineageSectionType["Group"] = 0] = "Group";
    LineageSectionType[LineageSectionType["Anchor"] = 1] = "Anchor";
    LineageSectionType[LineageSectionType["Owners"] = 2] = "Owners";
})(LineageSectionType = exports.LineageSectionType || (exports.LineageSectionType = {}));
function lineageItemKey(params) {
    var sectionKey = params.lineageSection.key;
    var itemKey = params.lineageItem.lineageItemType;
    return sectionKey + "-" + itemKey;
}
exports.lineageItemKey = lineageItemKey;
/**
 * The anchor in the lineage nav uses its own special anchorCount, but in many cases, we want it to
 * be the same as the anchor pane's count. This helper function extracts the anchor count from the
 * configuration so it can be passed into the LineageNav separately but still be defined in one place.
 */
function getAnchorCountFromConfig(config, counts) {
    var anchorSection = config.find(function (s) { return s.sectionType === LineageSectionType.Anchor; });
    var anchorItem = anchorSection && anchorSection.items[0];
    return (anchorItem && counts) ? anchorItem.count(counts) : null;
}
exports.getAnchorCountFromConfig = getAnchorCountFromConfig;
//# sourceMappingURL=LineageConfiguration.js.map